module.exports = __webpack_public_path__ + "img/05.a6d78da7.png";